export default __webpack_public_path__ + "static/media/swift.13d82fd5.png";